import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { documnetTypeModel } from '../../Interfaces/index'

interface DocumentTypeState {
  documentTypes: documnetTypeModel[]
}

const initialState: DocumentTypeState = {
  documentTypes: []
}

const documentTypeSlice = createSlice({
  name: 'documentType',
  initialState,
  reducers: {
    setDocumentTypes(state, action: PayloadAction<documnetTypeModel[]>) {
      state.documentTypes = action.payload
    }
  }
})

export const { setDocumentTypes } = documentTypeSlice.actions
export const documentTypeReducer = documentTypeSlice.reducer
